export const wheatTypes = [
    { value: 'яровая', label: 'яровая'  },
    { value: 'озимая', label: 'озимая'  },
];

export const wheatSorts = [
    { value: 'мягкая краснозерная', label: 'мягкая краснозерная'  },
    { value: 'мягкая белозерная', label: 'мягкая белозерная'  },
    { value: 'твердая', label: 'твердая'  },
];

export const wheatClasses = [
    { value: 1, label: '1й класс'  },
    { value: 2, label: '2й класс'  },
    { value: 3, label: '3й класс'  },
    { value: 4, label: '4й класс'  },
    { value: 5, label: '5й класс'  },
    //{ value: 5.1, label: '5й класс (фураж)'  },
];